/**
 * Constantes du module usage-profile
 */

/** Libellés des niveaux/types de bâtiment pour l'affichage */
export const BUILDING_LEVEL_LABEL: Record<string, string> = {
    appartement: "Partie",
    maison: "Bâtiment",
    maison_appartement: "Partie",
    immeuble: "Bâtiment",
    groupe: "Groupe",
    maison_immeuble: "Bâtiment",
} as const
